module.exports = __webpack_public_path__ + "static/media/zoo_1.05f27919.jpg";